<ng-lottie [options]="lottieOptions"></ng-lottie>
<div class="center mb-5">
  <button class="btn btn-admin-green" (click)="onClick()">{{ 'lottieAlert.buttonCaption' | translate }}</button>
</div>
<p class="text-center m-3" *ngIf="isOpen">{{ error | json }}</p>
